<template>
  <div>

    <vx-card>
      <vs-table
        stripe
        ref="table"
        :data="members"
        search

        pagination
        :sst="true"
        :total="(totalCount) ? totalCount : 1"
        :max-items="itemsPerPage"
        @search="handleTableSearch"
        @selected="handleTableSelected"
        @change-page="handleTableChangePage" >

        <template slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-select id="tableSelect" autocomplete label="" v-model="itemsPerPage" class="w-1/12" @change="handleChangeTablePerPage">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in itemsPerPageOptions"/>
          </vs-select>
        </template>

        <template slot="thead">
          <vs-th class="w-1/12" sort-key="index">No.</vs-th>
          <vs-th class="w-1/12" sort-key="memberid">ID</vs-th>
          <vs-th class="w-1/12" sort-key="name">이름</vs-th>
          <vs-th sort-key="email">이메일</vs-th>
          <vs-th class="th-fix-created_at" sort-key="created_at">가입일</vs-th>
          <vs-th class="th-fix-management" ></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

            <!-- No. -->
            <vs-td>
              {{startNo + indextr}}
            </vs-td>

            <!-- ID -->
            <vs-td>
              {{data[indextr].username}}
            </vs-td>

            <!-- 이름 -->
            <vs-td>
              {{data[indextr].name}}
            </vs-td>

            <!-- 이메일 -->
            <vs-td>
              {{data[indextr].email}}
            </vs-td>

            <!-- 가입일 -->
            <vs-td class="td-fix-created_at">
              {{data[indextr].created_at}}
            </vs-td>

            <!-- 관리 -->
            <vs-td class="td-fix-management text-right">
              <vs-button class="" color="primary" type="border" @click="(event)=>{ handleItemClickModified(event, tr.id) }">수정</vs-button>
              <vs-button class="ml-4" color="#EDEDED" text-color="black" type="filled" @click.stop>삭제</vs-button>
            </vs-td>

          </vs-tr>

          <vs-tr>
            <vs-td colspan="6" >
              <vs-col class="w-full" vs-type="flex" vs-justify="flex-end">
                <vs-button color="secondary" @click="handleFooterClickRegister" @click.stop>회원등록</vs-button>
              </vs-col>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>


<script>
import VueCookie from 'vue-cookie'
import memberModule from '@/store/member/memberModule.js'

export default {
  data () {
    return {
      selected: [],
      itemsPerPageOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 }
      ],
      members: [],

      // pagination
      startNo: 1,
      totalCount: 1,
      currentPage: 1,
      itemsPerPage: 10
    }
  },
  computed: {
  },

  created () {

    // 동적 모듈 등록
    if (!this.$store.hasModule('member')) {
      this.$store.registerModule('member', memberModule)
    }

    this.loadMembers(this.currentPage)

  },
  mounted () {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.table.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  beforeDestroy () {
    // 동적 모듈 삭제
    this.$store.unregisterModule('member')
  },

  methods: {
    // 회원목록 불러오기
    async loadMembers (page, keyword) {
      page = this.is_number(page) ? page : 1
      const perPage = this.itemsPerPage
      await this.$store.dispatch('member/LOAD_MEMBERS', {page, perPage, keyword})

      const list = this.$store.state.member.listInfo

      // 페이지네이션 정보
      this.currentPage = list.current_page
      this.itemsPerPage = list.per_page
      this.totalCount = list.total
      this.startNo = (this.itemsPerPage * (this.currentPage - 1)) + 1

      // 보여지는 회원 리스트
      this.members = list.data
    },

    // 수정페이지로 이동
    moveModified (id) {
      // 선택한 사용자 ID 저장
      VueCookie.set(this.$store.state.member.COOKIE_KEY_CURRENT_USER_ID, id)
      this.$router.push({ path: 'detail' })
    },

    // 등록페이지로 이동
    moveRegister () {
      // 선택한 사용자 ID 삭제
      VueCookie.set(this.$store.state.member.COOKIE_KEY_CURRENT_USER_ID, '')
      this.$router.push({ path: 'detail' })
    },


    //===== [ dev ] =====

    is_number (v) {
      const reg = /^(\s|\d)+$/
      return reg.test(v)
    },


    //===== [ handler ] ======

    handleItemClickModified (event, id) {
      this.moveModified(id)
    },
    handleFooterClickRegister () {
      this.moveRegister()
    },
    handleChangeTablePerPage (per_page) {
      if (this.is_number(per_page)) {
        this.itemsPerPage = per_page
      }
      this.currentPage = 1
      this.loadMembers(this.currentPage)
    },
    handleTableChangePage (page) {
      this.loadMembers(page)
    },
    handleTableSearch (keyword) {
      const page = this.currentPage
      this.loadMembers(page, keyword)
    },
    handleTableSelected (tr) {
      if (!tr) {
        return
      }
      this.moveModified(tr.id)
    }
  }//methods
}
</script>

<style scoped>
.th-fix-created_at,
.td-fix-created_at{
  width:165px;
}
.th-fix-management,
.td-fix-management{
  width:214px;
}

@media (max-width: 992px) {
  .th-fix-management,
  .td-fix-management{
    display: none;
  }
}
</style>
